import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { BusyIndicatorService } from './services/busy-indicator.service';
import { LayoutService } from './services/layout.service';
import { ThemeService } from './services/theme.service';

export function provideLayout(): EnvironmentProviders {
  return makeEnvironmentProviders([BusyIndicatorService, LayoutService, ThemeService]);
}
